var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('popup',{attrs:{"hide-footer":true,"on-enter":_vm.hidePopup,"is-visible":_vm.isVisible},on:{"close":_vm.hidePopup},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]},proxy:true},{key:"body",fn:function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }